import React, { Component } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Cascader,
  Upload,
  InputNumber,
  DatePicker,
  Spin,
  Icon,
  Modal,
  Popconfirm,
  Tree,
  Radio,
  Checkbox,
  AutoComplete,
} from "antd";
import { app, api, config } from "../../app";
import PropTypes from "prop-types";
import _ from "underscore";
import moment from "moment";
import Mockjs from "mockjs";
import date_locale from "antd/lib/date-picker/locale/zh_CN";
import addressOptions from "../../util/cascader-address-options";
import command from "../notice/command";
import "../../css/treeSelect.css";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const TreeNode = Tree.TreeNode;

/**
 * 上传之前
 * @param file
 */
function beforeUpload(file) {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    app.alert("图片最大2MB！", "error");
    return Promise.reject(false);
  }
  return Promise.resolve(true);
}

function service_subjectToOptions(item, disabled = false) {
  let info = {
    value: item.id,
    label: item.subject_name,
  };
  if (disabled) info.disabled = true;
  if (item.subclass) {
    info.children = item.subclass.map((s) => {
      return service_subjectToOptions(s);
    });
  }
  return info;
}

function getServiceSubjectId(items, id) {
  for (let i = 0; i < items.length; i++) {
    for (let j = 0; j < items[i].children.length; j++) {
      if (items[i].children[j].value === id) {
        return [items[i].value, id];
      }
    }
  }
}

class TaskAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      loading: true,
      type: "",
      team_loading: true,
      player_modal: false,
      player_modal2: false,
      submit_loading: false,
      rights: undefined,
      level_id_str: undefined,
      team_id: undefined,
      teamList: [],
      ally_list: [],
      ally_grade: "",
      list: [],
      sign: null,
      apply_select: { volunteer_id: [], checks: [] },
      apply_select2: { volunteer_id: [], checks: [] },
      apply_select3: undefined,
      apply_select_rear: { volunteer_id: [], checks: [] },
      object_volunteer_rear: { indexno: [], checks: [] },
      object_volunteer: { indexno: [], checks: [] },
      apply_select_rear2: { volunteer_id: [], checks: [] },
      apply_select_rear3: { volunteer_id: [], checks: [] },
      playerList: {},
      checkedKeyS: [],
      checkedKey: undefined,
      playerList2: [],
      playerList3: [],
      playerChecks: [],
      playerChecks2: [],
      playerChecks3: [],
      lastParts: [],
      lastParts2: [],
      searchplayerList: [],
      detailData: {},
      player_modal_key: null,
      player_modal_key2: null,
      player_modal_key3: null,
      modal_search_value: null,
      modal_search_value2: null,
      modal_search_value3: null,
      principal_type: null,
      teamnos: null,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    let { type } = this.props;
    this.setData({ loading: false, team_loading: false, type: type });
    await this.handleDefaultData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 获取默认数据
   * @returns {Promise<void>}
   */
  handleDefaultData = async () => {
    await this.setData({ loading: true });
    let params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.ReportsOption, params);
    if (flag === 1) {
      data.service_subject = data.service_subject.map((s) =>
        service_subjectToOptions(s, true)
      );
      let { type, edit_id, isDo } = this.props;
    } else {
      data = {};
      app.alert(msg, "error");
    }
    let { type, edit_id, isDo } = this.props,
      // state = await this.ClassList();
      state = {};
    setTimeout(async () => {
      if (type == "2") {
        await this.handleSelectPlayer3("1");
      }
      if (edit_id) {
        if (isDo) {
          state = await this.handleDetailData(edit_id, data.service_subject);
          const report_type =
            data.type.find((t) => state.detailData.type === t.id) || {};
          data.service_subject = data.service_subject.map((s) => {
            if (
              report_type &&
              (report_type.sid || []).indexOf(s.value) !== -1
            ) {
              s.disabled = false;
            } else {
              s.disabled = true;
            }
            return s;
          });
        } else {
          state = await this.handleDetailData(edit_id, data.service_subject);
          const report_type =
            data.type.find((t) => state.detailData.type === t.id) || {};
          data.service_subject = data.service_subject.map((s) => {
            if (
              report_type &&
              (report_type.sid || []).indexOf(s.value) !== -1
            ) {
              s.disabled = false;
            } else {
              s.disabled = true;
            }
            return s;
          });
        }
      }
      await this.setData(
        Object.assign(state, { dataInfo: data, loading: false, isDo: isDo })
      );
    }, 1000);
  };

  /**
   * 任务详情
   * @param id
   * @param service_subject
   * @returns {Promise<*>}
   */
  handleDetailData = async (id, service_subject) => {
    let params = {
        task_id: id,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
        type: 1,
      },
      { flag, data, msg } = await app.post(api.TaskDetails, params);
    if (flag === 1) {
      let {
        principal,
        object_volunteer,
        object_volunteer_rear,
        is_domestic,
      } = data;
      let {
        playerList3,
        ally_list,
        checkedKeyS,
        rights,
        team_id,
        teamnos,
      } = this.state;
      if (is_domestic === "1") {
        data.area = [data.province, data.city, data.region];
      }
      data.principal = principal ? principal.map((p) => p.indexno) : [];
      data.service_subject = getServiceSubjectId(
        service_subject,
        data.service_subject
      );
      let ov_vname = [],
        ov_indexno = [],
        ov_checks = [],
        ovr_vname = [],
        ovr_indexno = [],
        ovr_checks = [],
        team_vname = [],
        team_checks = [],
        level_id_str = "";
      for (let i = 0; i < (object_volunteer || []).length; i++) {
        ov_indexno.push(object_volunteer[i].indexno);
        if (object_volunteer[i].bsrno) {
          ov_vname.push(
            object_volunteer[i].vname + "(" + object_volunteer[i].bsrno + ")"
          );
        } else {
          ov_vname.push(object_volunteer[i].vname);
        }
        if (object_volunteer[i].bsrno) {
          ov_checks.push(
            `3-${object_volunteer[i].vname}-${object_volunteer[i].indexno}-${object_volunteer[i].bsrno}`
          );
        } else {
          ov_checks.push(
            `3-${object_volunteer[i].vname}-${
              object_volunteer[i].indexno
            }-${""}`
          );
        }
      }
      for (let j = 0; j < (object_volunteer_rear || []).length; j++) {
        ovr_indexno.push(object_volunteer_rear[j].indexno);
        if (object_volunteer_rear[j].bsrno) {
          ovr_vname.push(
            object_volunteer_rear[j].vname +
              "(" +
              object_volunteer_rear[j].bsrno +
              ")"
          );
        } else {
          ovr_vname.push(object_volunteer_rear[j].vname);
        }
        if (object_volunteer_rear[j].bsrno) {
          ovr_checks.push(
            `3-${object_volunteer_rear[j].vname}-${object_volunteer_rear[j].indexno}-${object_volunteer_rear[j].bsrno}`
          );
        } else {
          ovr_checks.push(
            `3-${object_volunteer_rear[j].vname}-${
              object_volunteer_rear[j].indexno
            }-${""}`
          );
        }
      }

      data.object_volunteer = ov_vname.join("、");
      data.object_volunteer_rear = ovr_vname.join("、");
      if (data.ally_way == "1") {
        data.teamname = data.team_info[0].teamname;
      } else {
        data.apply_select2 = data.team_info;
        for (let k = 0; k < (data.apply_select2 || []).length; k++) {
          team_vname.push(data.apply_select2[k].teamname);
          team_checks.push(
            `3-${data.apply_select2[k].teamname}-${data.apply_select2[k].teamno}`
          );
        }
        team_id = team_checks
          .map((item) => {
            if (item.split("-").length === 3) {
              return item.split("-").pop();
            } else {
              return "";
            }
          })
          .filter(Boolean)
          .join(",");
        data.apply_select2 = team_vname.join("、");
      }
      data.task_strat_time = data.action_time;
      data.task_end_time = data.recruit_time;
      data.task_address = data.address;
      data.need_number = Number(data.action_people_number);
      data.task_duration = Number(data.service_time);

      if (data.ally_way == "2") {
        data.checkedKeyS = checkedKeyS;
        for (let x in playerList3) {
          if (data.ally_grade == playerList3[x].grade_name) {
            ally_list = playerList3[x].province_list;
          }
        }
        for (let m in data.province_list) {
          data.checkedKeyS.push(data.province_list[m].area_name);
        }
        level_id_str = checkedKeyS.join(",");
        let list = [];
        for (let l in data.team_info) {
          list.push(data.team_info[l].teamno);
          teamnos = list.join(",");
        }
      }
      if (data.ally_way == "1") {
        return {
          detailData: data,
          searchplayerList: principal,
          object_volunteer: { indexno: ov_indexno, checks: ov_checks },
          object_volunteer_rear: { indexno: ovr_indexno, checks: ovr_checks },
          isDo: true,
        };
      } else {
        return {
          detailData: data,
          searchplayerList: principal,
          object_volunteer: { indexno: ov_indexno, checks: ov_checks },
          object_volunteer_rear: { indexno: ovr_indexno, checks: ovr_checks },
          isDo: true,
          ally_list: ally_list,
          rights: data.ally_grade,
          checkedKey: data.ally_grade,
          ally_grade: data.ally_grade,
          level_id_str: level_id_str,
          checkedKeyS: data.checkedKeyS,
          teamnos: teamnos,
          playerChecks2: team_checks,
          team_id: team_id,
        };
      }
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  // 任务类型
  ClassList = async () => {
    let params = {
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.ReportsOption, params);
    if (flag === 1) {
      this.setData({ PositionList: data.type });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  /**
   * 表单提交
   * @param e
   */
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.submit_loading) return;
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let { select_team, type } = this.props;
        let {
            apply_select,
            apply_select2,
            apply_select3,
            object_volunteer_rear,
            object_volunteer,
            apply_select_rear,
            apply_select_rear2,
            playerChecks,
            team_id,
            playerChecks2,
            playerChecks3,
            lastParts,
            lastParts2,
            ally_grade,
            ally_list,
            checkedKeyS,
          } = this.state,
          { teamno, onClose } = this.props;
        values.principal = values.principal || [];
        values.ally_way = type;
        console.log("object_volunteer_rear", object_volunteer_rear);
        console.log("object_volunteer", object_volunteer);
        console.log(
          Number(
            values.principal.length +
              object_volunteer_rear.checks.length +
              object_volunteer.checks.length
          )
        );
        if (
          Number(
            values.principal.length +
              object_volunteer_rear.checks.length +
              object_volunteer.checks.length
          ) > values.need_number
        ) {
          app.alert("所选队员已超过出队人数！");
          await this.setData({ submit_loading: false });
          return;
        }

        if (values.ally_way == "1") {
          values.teamno = select_team.teamno;
        } else if (values.ally_way == "2") {
          values.object_team = team_id;
        }
        values.team_id = team_id;
        values.task_integral = Math.floor(values.task_duration) * 5;

        if (values.ally_way == "2") {
          values.ally_grade = ally_grade;
          values.ally_rights_ids = "";
          for (let i in ally_list) {
            for (let j in checkedKeyS) {
              if (ally_list[i].area_name == checkedKeyS[j]) {
                values.ally_rights_ids += "," + ally_list[i].area_id;
                if (values.ally_rights_ids.startsWith(",")) {
                  values.ally_rights_ids = values.ally_rights_ids.substring(1);
                }
              }
            }
          }
        }
        await this.setData({ submit_loading: true });
        values.account = app.getData("account");
        values.indexno = app.getData("indexno");
        values.service_subject =
          values.service_subject[values.service_subject.length - 1]; //志愿服务科目
        if (typeof values.apply_type === "string") {
          values.apply_type = values.apply_type;
        } else if (Array.isArray(values.apply_type)) {
          values.apply_type = values.apply_type.join(",");
        }
        // values.apply_type = values.apply_type.join(',');
        values.principal = (values.principal || []).join(",");

        lastParts = [];
        lastParts2 = [];

        if (values.is_domestic === "1") {
          values.province = values.area[0];
          values.city = values.area[1];
          values.region = values.area[2];
        }
        for (let i = 0; i < object_volunteer.checks.length; i++) {
          if (object_volunteer.checks[i].indexOf("-")) {
            let arr = object_volunteer.checks[i].split("-");
            if (arr.length === 4) {
              lastParts.push(arr[arr.length - 2]);
            }
          }
        }

        for (let i = 0; i < object_volunteer_rear.checks.length; i++) {
          if (object_volunteer_rear.checks[i].indexOf("-")) {
            let arr = object_volunteer_rear.checks[i].split("-");
            if (arr.length === 4) {
              lastParts2.push(arr[arr.length - 2]);
            }
          }
        }

        values.apply_select = lastParts.join(",");
        values.apply_select_rear = lastParts2.join(",");

        values.task_data = values.task_strat_time.format("YYYY-MM-DD");
        values.task_strat_time = values.task_strat_time.format(
          "YYYY-MM-DD HH:mm:00"
        );
        values.task_end_time = values.task_end_time
          ? values.task_end_time.format("YYYY-MM-DD HH:mm:00")
          : "";
        let params = Object.assign({}, values);
        delete params.area;
        let { edit_id } = this.props,
          result = { flag: 0 },
          msg = "提交";
        if (edit_id) {
          params.task_id = edit_id;
          msg = "编辑";
          result = await app.post(api.editTask, params);
        } else {
          params.submit_type = "2";
          result = await app.post(api.ReportsAddTask, params);
        }
        await this.setData({ submit_loading: false });
        if (result.flag === 1) {
          app.alert(msg + "成功", "success");
          onClose(true);
        } else {
          app.alert(result.msg || msg + "失败", "error");
        }
      }
    });
  };

  /**
   * type 变更
   * @param type
   */
  handleTypeChange = (type) => {
    const { dataInfo } = this.state,
      report_type = dataInfo.type.find((t) => type === t.id) || {};
    const service_subject = dataInfo.service_subject.map((s) => {
      if (report_type && (report_type.sid || []).indexOf(s.value) !== -1) {
        s.disabled = false;
      } else {
        s.disabled = true;
      }
      return s;
    });
    dataInfo.service_subject = [...service_subject];
    this.props.form.setFieldsValue({ service_subject: undefined });
    this.setData({ dataInfo });
  };

  /**
   * 表单清空
   */
  handleReset = () => {
    let { type } = this.state;
    this.state.detailData.secret = undefined;
    if (type == "2") {
      this.state.checkedKey = undefined;
      this.state.checkedKeyS = [];
    }
    this.props.form.resetFields();
  };

  /**
   * 搜索人员数据
   * @returns {Promise<void>}
   */
  handleSearchPlayer = async (search_val) => {
    if (!search_val) {
      await this.setData({ searchplayerList: [] });
      return;
    }
    await this.setData({ principal_loading: true });
    let params = {
        search_val,
        search_type: this.state.principal_type || "searchform_name",
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.HomeSearch, params);
    if (flag === 1) {
      let { object_volunteer, object_volunteer_rear } = this.state;

      object_volunteer = object_volunteer.indexno.concat(
        object_volunteer_rear.indexno
      );
      data.forEach((ov) => {
        ov.disabled = object_volunteer.indexOf(ov.indexno) !== -1;
      });
    } else {
      data = [];
      app.alert(msg, "error");
    }

    await this.setData({ searchplayerList: data, principal_loading: false });
  };

  /**
   * 选择队员
   */
  handleSelectPlayer = async (key) => {
    let { select_team, edit_id, type } = this.props;
    let { team_id, teamno, teamnos, apply_select2 } = this.state;
    if (type == "1") {
      teamno = select_team.teamno;
    } else if (type == "2") {
      teamno = teamnos;
    }

    app.alert("正在加载内容~", "loading");
    const values = this.props.form.getFieldsValue();
    const params = {
      teamno: teamno,
      apply_type: Array.isArray(values.apply_type)
        ? values.apply_type.join(",")
        : values.apply_type,
      account: app.getData("account"),
      indexno: app.getData("indexno"),
    };
    let { flag, data, msg } = await app.post(api.ReportsGetTeamUserAll, params);
    app.alertDestroy();
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    let state = {
      playerList: data,
      player_modal: true,
      player_modal_key: key,
    };
    switch (key) {
      case "1":
        state.playerChecks = this.state.object_volunteer.checks || [];
        break;
      case "2":
        state.playerChecks = this.state.object_volunteer_rear.checks || [];
        break;
    }
    await this.setData(state);
    // this.props.form.validateFieldsAndScroll(async (err, values) => {
    //
    // });
  };

  /**
   * 选择队伍
   */
  handleSelectPlayer2 = async (key) => {
    let { rights, level_id_str } = this.state;
    app.alert("正在加载内容~", "loading");
    // this.props.form.validateFieldsAndScroll(async (err, values) => {
    const params = {
      grade_name: rights,
      province: level_id_str,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg } = await app.post(api.taskTeamAll, params);
    app.alertDestroy();
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    let state = {
      playerList2: data,
      player_modal2: true,
      player_modal_key2: key,
    };
    switch (key) {
      case "1":
        state.playerChecks2 = this.state.playerChecks2 || [];
        break;
    }
    await this.setData(state);
    // });
  };

  /**
   * 选择任务等级
   */
  handleSelectPlayer3 = async (key) => {
    let { select_team, edit_id } = this.props;
    app.alert("正在加载内容~", "loading");
    // this.props.form.validateFieldsAndScroll(async (err, values) => {
    const params = {
      account: app.getData("account"),
      indexno: app.getData("indexno"),
    };
    let { flag, data, msg } = await app.post(api.taskAllyGrade, params);
    app.alertDestroy();
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    let state = {
      playerList3: data,
    };
    switch (key) {
      case "1":
        state.playerChecks3 = this.state.playerChecks3 || [];
        break;
    }
    await this.setData(state);
    // });
  };

  /**
   * 关闭队员选择框
   * @returns {Promise<void>}
   */
  handleClosePlayerModal = async () => {
    await this.setData({
      player_modal: false,
      modal_search_value: "",
      playerChecks: [],
    });
  };

  /**
   * 关闭队伍选择框
   * @returns {Promise<void>}
   */
  handleClosePlayerModal2 = async () => {
    await this.setData({
      player_modal2: false,
      modal_search_value2: "",
    });
  };

  /**
   * 关闭等级选择框
   * @returns {Promise<void>}
   */
  handleClosePlayerModal3 = async () => {
    await this.setData({
      player_modal3: false,
      modal_search_value3: "",
    });
  };

  /**
   * 选择队员
   * @param playerChecks
   */
  handleSelPlayer = (playerChecks) => {
    this.setData({ playerChecks });
  };

  /**
   * 选择队伍
   * @param playerChecks2
   */
  handleSelPlayer2 = (playerChecks2) => {
    let { team_id } = this.state;
    team_id = playerChecks2
      .map((item) => {
        if (item.split("-").length === 3) {
          return item.split("-").pop();
        } else {
          return "";
        }
      })
      .filter(Boolean)
      .join(",");
    this.setData({ playerChecks2, team_id });
  };

  /**
   * 选择等级
   * @param playerChecks3
   */
  handleSelPlayer3 = (playerChecks3) => {
    this.setData({ playerChecks3 });
  };

  /**
   * 确认选择队员
   * @param e
   */
  handleConfirmPlayerSel = (e) => {
    e.preventDefault();
    let { playerChecks, player_modal_key, list } = this.state,
      principal = this.props.form.getFieldValue("principal") || [];
    // if (playerChecks.length > 0) {
    let vnames = [],
      indexnos = [],
      has_vname = [];
    switch (player_modal_key) {
      case "1":
        let { object_volunteer_rear } = this.state;
        for (let i = 0; i < playerChecks.length; i++) {
          let arr = playerChecks[i].split("-");
          if (arr.length === 4 && indexnos.indexOf(arr[2]) === -1) {
            if (arr[3] != "") {
              vnames.push(arr[1] + "(" + arr[3] + ")");
            } else {
              vnames.push(arr[1]);
            }
            indexnos.push(arr[2]);
            if (
              principal
                .concat(object_volunteer_rear.indexno)
                .indexOf(arr[2]) !== -1
            ) {
              has_vname.push(arr[1]);
            }
          }
        }
        if (has_vname.length > 0) {
          app.alert(
            `现场指挥或后台出队队员已包含【${has_vname.join("、")}】`,
            "warn",
            "40%",
            2.5
          );
          return;
        }
        this.props.form.setFieldsValue({
          object_volunteer: vnames.join("、"),
        });
        this.state.object_volunteer.indexno = indexnos;
        this.state.object_volunteer.checks = playerChecks;
        break;
      case "2":
        let { object_volunteer } = this.state;
        for (let i = 0; i < playerChecks.length; i++) {
          let arr = playerChecks[i].split("-");
          if (arr.length === 4 && indexnos.indexOf(arr[2]) === -1) {
            if (arr[3] != "") {
              vnames.push(arr[1] + "(" + arr[3] + ")");
            } else {
              vnames.push(arr[1]);
            }
            indexnos.push(arr[2]);
            if (
              principal.concat(object_volunteer.indexno).indexOf(arr[2]) !== -1
            ) {
              has_vname.push(arr[1]);
            }
          }
        }
        if (has_vname.length > 0) {
          app.alert(
            `现场指挥或现场出队队员已包含【${has_vname.join("、")}】`,
            "warn",
            "40%",
            2.5
          );
          return;
        }
        this.props.form.setFieldsValue({
          object_volunteer_rear: vnames.join("、"),
        });
        this.state.object_volunteer_rear.indexno = indexnos;
        this.state.object_volunteer_rear.checks = playerChecks;
        break;
    }

    this.setData({ player_modal: false, modal_search_value: "" });
    // } else {
    //     app.alert("请选择队员！")
    // }
  };

  /**
   * 确认选择队伍
   * @param e
   */
  handleConfirmPlayerSel2 = (e) => {
    e.preventDefault();
    // this.props.form.validateFieldsAndScroll(async (err, values) => {
    let { playerChecks2, player_modal_key2 } = this.state,
      principal = this.props.form.getFieldValue("principal") || [];
    // if (playerChecks.length > 0) {
    let vnames = [],
      has_vname = [],
      teamList = [];
    switch (player_modal_key2) {
      case "1":
        let { apply_select_rear2, teamnos, teamno } = this.state;
        let { type } = this.props;

        for (let i = 0; i < playerChecks2.length; i++) {
          let arr = playerChecks2[i].split("-");
          if (arr.length === 3 && vnames.indexOf(arr[1]) === -1) {
            vnames.push(arr[1]);
            teamList.push(arr[2]);

            if (type == "2") {
              teamno = teamList.join(",");
            }
            if (
              principal.concat(apply_select_rear2.indexno).indexOf(arr[2]) !==
              -1
            ) {
              has_vname.push(arr[1]);
            }
          }
        }

        this.props.form.setFieldsValue({
          apply_select2: vnames.join("、"),
        });
        this.state.apply_select2.checks = playerChecks2;
        this.state.teamnos = teamno;
        break;
    }
    this.setData({ player_modal2: false, modal_search_value2: "" });
    // } else {
    //     app.alert("请选择队员！")
    // }
    // });
  };

  /**
   * 确认选择等级
   * @param e
   */
  handleConfirmPlayerSel3 = (e) => {
    e.preventDefault();
    const values = this.props.form.getFieldsValue();
    // this.props.form.validateFieldsAndScroll(async (err, values) => {
    let { playerChecks3, player_modal_key3 } = this.state,
      principal = this.props.form.getFieldValue("principal") || [];
    // if (playerChecks.length > 0) {
    let vnames = [],
      has_vname = [];
    switch (player_modal_key3) {
      case "1":
        let { apply_select_rear3 } = this.state;
        for (let i = 0; i < playerChecks3.length; i++) {
          let arr = playerChecks3[i].split("-");
          if (arr.length === 3 && vnames.indexOf(arr[1]) === -1) {
            vnames.push(arr[1]);
            if (
              principal.concat(apply_select_rear3.indexno).indexOf(arr[2]) !==
              -1
            ) {
              has_vname.push(arr[1]);
            }
          }
        }
        this.props.form.setFieldsValue({
          apply_select3: vnames.join("、"),
        });
        this.state.apply_select3.checks = playerChecks3;
        break;
    }
    this.setData({ player_modal3: false, modal_search_value3: "" });
    // } else {
    //     app.alert("请选择队员！")
    // }
    // });
  };

  /**
   * 选择出队队员搜索
   **/
  handleModalSearchPlayer = (modal_search_value) =>
    this.setData({ modal_search_value });

  /**
   * 选择出队队伍
   **/
  handleModalSearchPlayer2 = (modal_search_value2) =>
    this.setData({ modal_search_value2 });

  /**
   * 选择队伍等级
   **/
  handleModalSearchPlayer3 = (modal_search_value3) =>
    this.setData({ modal_search_value3 });

  render() {
    let { select_team, edit_id, form, onDuration } = this.props,
      {
        getFieldDecorator,
        getFieldsValue,
        setFieldsValue,
        getFieldValue,
      } = form,
      {
        dataInfo,
        loading,
        apply_select,
        apply_select2,
        apply_select3,
        team_loading,
        teamList,
        searchplayerList,
        playerList,
        playerList2,
        playerList3,
        principal_loading,
        player_modal,
        player_modal2,
        player_modal3,
        playerChecks,
        playerChecks2,
        playerChecks3,
        lastParts,
        lastParts2,
        submit_loading,
        detailData,
        apply_select_rear,
        modal_search_value,
        modal_search_value2,
        modal_search_value3,
        PositionList,
        GradeList,
        isDo,
        ally_list,
        ally_grade,
        checkedKeyS,
        checkedKey,
        rights,
        level_id_str,
        type,
        team_id,
        teamnos,
      } = this.state,
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      formData = getFieldsValue([
        "object_team",
        "is_domestic",
        "service_subject",
        "task_strat_time",
        "whether_succeed",
        "event_img",
        "principal",
      ]),
      default_time_value = moment().second(0),
      dtv_minute = default_time_value.minute(),
      player_modal_search_count = 0;
    const loopPlayerTreeNode = ({ vname, bsrno, indexno }) => {
      if (bsrno) {
        let title = `${vname}【${bsrno}】`;
        if (
          modal_search_value &&
          (vname.indexOf(modal_search_value) > -1 ||
            bsrno.indexOf(modal_search_value) > -1)
        ) {
          const index = title.indexOf(modal_search_value);
          const beforeStr = title.substr(0, index);
          const afterStr = title.substr(index + modal_search_value.length);
          player_modal_search_count += 1;
          title = (
            <span>
              {beforeStr}
              <span style={{ backgroundColor: "rgb(143, 178, 201)" }}>
                {modal_search_value}
              </span>
              {afterStr}
            </span>
          );
        }
        let pmsc = document.getElementById("player_modal_search_count");
        if (pmsc) pmsc.innerHTML = `搜索记录数：${player_modal_search_count}条`;

        return (
          <TreeNode title={title} key={`3-${vname}-${indexno}-${bsrno}`} />
        );
      } else {
        let title = `${vname}`;
        if (
          modal_search_value &&
          (vname.indexOf(modal_search_value) > -1 ||
            bsrno.indexOf(modal_search_value) > -1)
        ) {
          const index = title.indexOf(modal_search_value);
          const beforeStr = title.substr(0, index);
          const afterStr = title.substr(index + modal_search_value.length);
          player_modal_search_count += 1;
          title = (
            <span>
              {beforeStr}
              <span style={{ backgroundColor: "rgb(143, 178, 201)" }}>
                {modal_search_value}
              </span>
              {afterStr}
            </span>
          );
        }
        let pmsc = document.getElementById("player_modal_search_count");
        if (pmsc) pmsc.innerHTML = `搜索记录数：${player_modal_search_count}条`;

        return <TreeNode title={title} key={`3-${vname}-${indexno}-${""}`} />;
      }
    };
    const loopPlayerTreeNode2 = ({ teamname, teamno }) => {
      let title = `${teamname}`;
      if (modal_search_value2 && teamname.indexOf(modal_search_value2) > -1) {
        const index = title.indexOf(modal_search_value2);
        const beforeStr = title.substr(0, index);
        const afterStr = title.substr(index + modal_search_value2.length);
        player_modal_search_count += 1;
        title = (
          <span style={{ width: "40%", display: "block" }}>
            {beforeStr}
            <span style={{ backgroundColor: "rgb(143, 178, 201)" }}>
              {modal_search_value2}
            </span>
            {afterStr}
          </span>
        );
      }
      let pmsc = document.getElementById("player_modal_search_count");
      if (pmsc) pmsc.innerHTML = `搜索记录数：${player_modal_search_count}条`;

      return (
        <TreeNode
          className="treenodes"
          title={title}
          key={`3-${teamname}-${teamno}`}
        />
      );
    };
    const loopPlayerTreeNode3 = ({ level_name, level_id }) => {
      let title = `${level_name}`;
      if (modal_search_value3 && level_name.indexOf(modal_search_value3) > -1) {
        const index = title.indexOf(modal_search_value3);
        const beforeStr = title.substr(0, index);
        const afterStr = title.substr(index + modal_search_value3.length);
        player_modal_search_count += 1;
        title = (
          <span>
            {beforeStr}
            <span style={{ backgroundColor: "rgb(143, 178, 201)" }}>
              {modal_search_value3}
            </span>
            {afterStr}
          </span>
        );
      }
      let pmsc = document.getElementById("player_modal_search_count");
      if (pmsc) pmsc.innerHTML = `搜索记录数：${player_modal_search_count}条`;

      return <TreeNode title={title} key={`3-${level_name}-${level_id}`} />;
    };
    const handleRadioChange2 = (e) => {
      this.state.detailData.secret = e.target.value;
    };
    const handleRadioChange = (e) => {
      this.state.rights = e.target.value;
      this.state.checkedKey = e.target.value;
      this.state.level_id_str = undefined;
      this.state.checkedKeyS = [];
      this.props.form.setFieldsValue({
        object_volunteer: "",
        object_volunteer_rear: "",
      });
      for (let i in this.state.playerList3) {
        if (e.target.value == playerList3[i].grade_name) {
          this.state.ally_grade = this.state.playerList3[i].grade_name;
          this.state.ally_list = this.state.playerList3[i].province_list;
        }
      }
      this.state.object_volunteer_rear.checks = [];
      this.state.object_volunteer.checks = [];
    };
    const handleCheckboxChange = (e) => {
      this.state.checkedKeyS = e;
      console.log(this.state.checkedKeyS);
      this.state.level_id_str = e.join(",");
      this.props.form.setFieldsValue({
        object_volunteer: "",
        object_volunteer_rear: "",
        apply_select2: "",
      });
      this.state.object_volunteer_rear.checks = [];
      this.state.object_volunteer.checks = [];
      this.state.playerChecks2 = [];
      this.state.teamnos = "";
    };
    const CheckboxChange = (e) => {
      if (this.state.sign) {
        if (this.state.sign <= e.length) {
          this.state.sign = e.length;
        } else {
          this.props.form.setFieldsValue({
            object_volunteer: "",
            object_volunteer_rear: "",
          });
          this.state.object_volunteer_rear.checks = [];
          this.state.object_volunteer.checks = [];
          this.state.sign = e.length;
        }
      } else {
        this.state.sign = e.length;
      }
    };
    if (dtv_minute >= 30) {
      default_time_value.minute(30);
    } else {
      default_time_value.minute(0);
    }
    return loading ? (
      <div style={{ marginTop: "35vh", textAlign: "center" }}>
        <Spin size="large" />
      </div>
    ) : (
      <div className="task">
        <Form onSubmit={this.handleSubmit}>
          {edit_id && (
            <div
              style={{
                padding: 10,
                border: "1px gray dashed",
                width: "50%",
                margin: "0 auto",
                display: "flex",
              }}
            >
              {detailData.audit_status == "0" ? (
                <p> 审核状态： {detailData.audit_name}</p>
              ) : (
                <div>
                  <p>审核人： {detailData.audit_admin}</p>
                  <p>审核状态： {detailData.audit_name}</p>
                  <p>审核时间： {detailData.audit_time}</p>
                  {detailData.detail && (
                    <p style={{ display: "flex" }}>
                      {" "}
                      <span style={{ width: "75px" }}>审核原因：</span>{" "}
                      <span style={{ color: "red", flexWrap: "wrap", flex: 1 }}>
                        {detailData.detail}
                      </span>
                    </p>
                  )}
                </div>
              )}
            </div>
          )}
          <div
            style={{
              width: "100%",
              height: 30,
              display: "flex",
              alignItems: "center",
              backgroundColor: "rgb(132 196 255)",
              fontWeight: "bold",
              fontSize: 20,
              padding: "20px 15px",
              borderRadius: "16px",
              color: "rgb(255 133 3)",
              justifyContent: "center",
            }}
          >
            任 务 信 息
          </div>
          <FormItem label="任务方式" {...formItemLayout}>
            {getFieldDecorator(
              "way",
              {}
            )(
              <div>
                <span style={{ fontWeight: "bold" }}>
                  {type == "1" ? "单队任务" : type == "2" ? "多队任务" : ""}
                </span>
                {type == "2" ? (
                  <span style={{ marginLeft: "5%", color: "rgb(255 133 3)" }}>
                    【多队任务】必须选择2支及以上出队队伍
                  </span>
                ) : null}
              </div>
            )}
          </FormItem>
          {type == "2" ? (
            <FormItem {...formItemLayout} label="任务等级">
              {getFieldDecorator("checkedKeyS", {
                rules: [
                  {
                    required: true,
                    message: "任务等级必选！",
                  },
                ],
                initialValue: detailData.checkedKeyS,
              })(
                <div>
                  <Radio.Group
                    style={{ width: "100%" }}
                    disabled={isDo}
                    onChange={handleRadioChange}
                    value={checkedKey}
                  >
                    {playerList3.map((item, index) => (
                      <Radio key={index} value={item.grade_name}>
                        {item.grade_name}
                      </Radio>
                    ))}
                  </Radio.Group>
                  {ally_list.length > 0 && (
                    <Checkbox.Group
                      value={checkedKeyS}
                      onChange={handleCheckboxChange}
                      className="Grade_checkbox"
                      disabled={isDo}
                    >
                      {ally_list.map((i, k) => (
                        <Checkbox
                          autoFocus={true}
                          key={i.area_id}
                          style={{ margin: "0 !important" }}
                          value={i.area_name}
                        >
                          {i.area_name}
                        </Checkbox>
                      ))}
                    </Checkbox.Group>
                  )}
                </div>
              )}
            </FormItem>
          ) : null}
          {type == "1" ? (
            <FormItem label="出队队伍" {...formItemLayout}>
              <span className="ant-form-text" style={{ fontWeight: "bold" }}>
                {(edit_id ? detailData.teamname : select_team.teamname) || "-"}
              </span>
            </FormItem>
          ) : type == "2" && rights && level_id_str ? (
            <FormItem label="出队队伍" {...formItemLayout}>
              {getFieldDecorator("apply_select2", {
                rules:
                  formData.service_subject &&
                  "123".indexOf(formData.service_subject[0]) === -1
                    ? []
                    : [
                        {
                          required: true,
                          message: "组织队伍必选！",
                        },
                      ],
                initialValue: detailData.apply_select2,
              })(
                <TextArea
                  style={{ cursor: "pointer" }}
                  placeholder="请选择队伍"
                  readOnly
                  onClick={() => this.handleSelectPlayer2("1")}
                  disabled={isDo}
                  autoSize={{ maxRows: 6, minRows: 2 }}
                />
              )}
            </FormItem>
          ) : null}
          <FormItem label="是否保密" {...formItemLayout}>
            {getFieldDecorator("secret", {
              rules: [{ required: true, message: "请选择是否保密!" }],
              initialValue: detailData.secret || undefined,
            })(
              <div>
                <Radio.Group
                  onChange={handleRadioChange2}
                  value={detailData.secret}
                  disabled={isDo}
                >
                  <Radio value="1">是</Radio>
                  <Radio value="0">否</Radio>
                </Radio.Group>
                <span
                  style={{
                    marginLeft: 5,
                    color: "rgb(255 133 3)",
                    fontSize: 12,
                  }}
                >
                  保密任务:
                  任务名称、任务地址、报名要求、任务简介等信息不对外公开显示
                </span>
              </div>
            )}
          </FormItem>
          <FormItem label="任务类型" {...formItemLayout}>
            {getFieldDecorator("type", {
              rules: [{ required: true, message: "任务类型必选！" }],
              initialValue: detailData.type,
            })(
              <Select
                placeholder="请选择"
                disabled={isDo}
                onChange={this.handleTypeChange}
              >
                {(dataInfo.type || []).map((t) => {
                  return (
                    <Option key={t.id} value={t.id}>
                      {t.name}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>
          <FormItem label="服务科目" {...formItemLayout}>
            {getFieldDecorator("service_subject", {
              rules: [{ required: true, message: "服务科目必选！" }],
              initialValue: edit_id ? detailData.service_subject : undefined,
            })(
              <Cascader
                options={dataInfo.service_subject || []}
                disabled={isDo}
                placeholder="请选择"
                notFoundContent="无记录"
              />
            )}
          </FormItem>
          <FormItem label="任务名称" {...formItemLayout}>
            {getFieldDecorator("title", {
              rules: [{ required: true, message: "任务名称必填！" }],
              initialValue: detailData.title,
            })(<Input placeholder="请输入任务名称" disabled={isDo} />)}
          </FormItem>
          <FormItem label="任务开始时间" {...formItemLayout}>
            {getFieldDecorator("task_strat_time", {
              rules: [{ required: true, message: "任务开始时间必选！" }],
              initialValue: detailData.task_strat_time
                ? moment(detailData.task_strat_time)
                : undefined,
            })(
              <DatePicker
                style={{ width: "100%" }}
                locale={date_locale}
                showTime={{ format: "HH:mm", minuteStep: 30 }}
                disabled={isDo}
                showToday={true}
                disabledDate={(current) => {
                  const today = moment().startOf("day");
                  const oneMonthAgo = moment(today)
                    .subtract(1, "months")
                    .startOf("day");
                  // 禁用一个月前的日期以及之后的日期，‌但今天的日期可选
                  return (
                    current &&
                    (current < oneMonthAgo || current.isAfter(today, "day"))
                  );
                }}
                defaultPickerValue={default_time_value}
                onOk={() => {
                  setFieldsValue({ task_end_time: null });
                }}
                format="YYYY年MM月DD日 HH:mm"
              />
            )}
            <span style={{ marginLeft: 10, color: "rgb(255 133 3)" }}>
              注:限制补录1个月以内的任务报表,请尽快如实上传
            </span>
          </FormItem>
          <FormItem label="是否完成" {...formItemLayout}>
            {getFieldDecorator("whether_succeed", {
              rules: [{ required: true, message: "是否完成必选！" }],
              initialValue: detailData.whether_succeed,
            })(
              <Radio.Group
                key={getFieldValue("whether_succeed")}
                disabled={isDo}
              >
                <Radio value="11">已完成</Radio>
                <Radio value="12">未完成</Radio>
              </Radio.Group>
            )}
          </FormItem>
          <FormItem label="任务结束时间" {...formItemLayout}>
            {getFieldDecorator("task_end_time", {
              rules: [{ required: true, message: "任务结束时间必选！" }],
              initialValue: detailData.task_end_time
                ? moment(detailData.task_end_time)
                : undefined,
            })(
              <DatePicker
                style={{ width: "100%" }}
                locale={date_locale}
                disabled={isDo}
                showTime={{ format: "HH:mm", minuteStep: 30 }}
                showToday={false}
                defaultPickerValue={default_time_value}
                disabledDate={(current) => {
                  if (edit_id) {
                    if (formData.task_strat_time) {
                      const endOfDay = moment(current).endOf("day");
                      return (
                        current &&
                        endOfDay < moment(formData.task_strat_time).endOf("day")
                      );
                    } else {
                      const endOfDay = moment(current).endOf("day");
                      return (
                        current &&
                        endOfDay <
                          moment(detailData.task_strat_time).endOf("day")
                      );
                    }
                  } else {
                    const endOfDay = moment(current).endOf("day");
                    return (
                      current &&
                      endOfDay < moment(formData.task_strat_time).endOf("day")
                    );
                  }
                }}
                format="YYYY年MM月DD日 HH:mm"
              />
            )}
            <span style={{ marginLeft: 10, color: "rgb(255 133 3)" }}>
              注:任务【已完成】状态,按任务结束时间计算,三天内的报表可以进行内容编辑,三天后报表固化状态则不能再修改
            </span>
          </FormItem>
          <FormItem label="救援范围" {...formItemLayout}>
            {getFieldDecorator("is_domestic", {
              rules: [{ required: true, message: "救援范围必选！" }],
              initialValue: detailData.is_domestic || "1",
            })(
              <Select placeholder="请选择" disabled={isDo}>
                <Option value="1">国内</Option>
                <Option value="2">国外</Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="省市区" {...formItemLayout}>
            {getFieldDecorator("area", {
              rules: [{ required: true, message: "省市区必选！" }],
              initialValue: detailData.area || undefined,
            })(
              <Cascader
                options={addressOptions}
                disabled={isDo}
                placeholder="请选择"
                notFoundContent="无记录"
                showSearch
              />
            )}
          </FormItem>
          <FormItem label="任务地址" {...formItemLayout}>
            {getFieldDecorator("task_address", {
              rules: [{ required: true, message: "任务地址必填！" }],
              initialValue: detailData.task_address || "",
            })(
              <TextArea autoSize={{ maxRows: 3, minRows: 2 }} disabled={isDo} />
            )}
          </FormItem>
          <FormItem label="出队人数" {...formItemLayout}>
            {getFieldDecorator("need_number", {
              rules: [{ required: true, message: "出队人数必填！" }],
              initialValue: detailData.need_number || "",
            })(
              <InputNumber
                style={{ width: "20%" }}
                disabled={isDo}
                min={0}
                step={1}
                precision={0} // 设置小数点位
              />
            )}
            人
            <span style={{ marginLeft: 10, color: "rgb(255 133 3)" }}>
              注:包括现场指挥、现场出队队员、后台出队队员。
            </span>
          </FormItem>
          <FormItem label="服务时长/人" {...formItemLayout}>
            {getFieldDecorator("task_duration", {
              rules: [{ required: true, message: "服务时长必填！" }],
              initialValue: detailData.task_duration || "",
            })(
              <InputNumber
                style={{ width: "20%" }}
                disabled={isDo}
                step={0.5}
                min={0}
                precision={1} // 设置小数点位数为1
              />
            )}
            小时
            <span style={{ marginLeft: 10, color: "rgb(255 133 3)" }}>
              每名队员完成任务打卡即可获得的服务时长
            </span>
          </FormItem>
          <FormItem label="任务积分/人" {...formItemLayout}>
            {getFieldDecorator("task_integral", {
              rules: [],
              initialValue: detailData.task_integral || "",
            })(
              <span style={{ width: "20%" }}>
                {Math.floor(parseFloat(getFieldValue("task_duration")) || 0) *
                  5 || 0}
              </span>
              // <InputNumber
              //   step={1}
              //   min={0}
              //   precision={1}
              //   formatter={(value) => `${value}`}
              //   parser={(value) => Math.round(value)}
              //   style={{ width: "20%" }}
              //   disabled={isDo}
              // />
            )}
            分
            <span style={{ marginLeft: "5%", color: "rgb(255 133 3)" }}>
              每名队员完成任务打卡即可获得的任务积分(1小时=5积分,不足1小时不计算)
            </span>
          </FormItem>
          <FormItem label="报名要求" {...formItemLayout}>
            {getFieldDecorator("apply_ask", {
              rules: [{ required: true, message: "报名要求必填！" }],
              initialValue: detailData.apply_ask || "",
            })(
              <TextArea
                placeholder="请输入报名要求"
                autoSize={{ maxRows: 3, minRows: 2 }}
                disabled={isDo}
              />
            )}
          </FormItem>
          <FormItem label="任务简介" {...formItemLayout}>
            {getFieldDecorator("task_remark", {
              rules: [{ required: true, message: "任务简介必填！" }],
              initialValue: detailData.task_remark || "",
            })(
              <TextArea
                placeholder="请输入任务简介"
                autoSize={{ maxRows: 3, minRows: 2 }}
                disabled={isDo}
              />
            )}
          </FormItem>
          <FormItem label="任务负责人/现场指挥" {...formItemLayout}>
            <span className="ant-form-text">
              <Select
                placeholder="请选择"
                defaultValue="searchform_name"
                style={{ width: 100 }}
                onChange={(value) => this.setData({ principal_type: value })}
              >
                <Option value="searchform_name">队员名称</Option>
                <Option value="searchform_code">存心编号</Option>
              </Select>
            </span>
            {getFieldDecorator("principal", {
              rules:
                (formData.service_subject &&
                  "13".indexOf(formData.service_subject[0]) === -1) ||
                (detailData.service_subject &&
                  "123".indexOf(detailData.service_subject[0]) === -1)
                  ? []
                  : [
                      {
                        required: true,
                        message: "现场指挥必选！",
                      },
                    ],
              initialValue: detailData.principal,
            })(
              <Select
                placeholder="请输入关键字搜索"
                onSearch={this.handleSearchPlayer}
                notFoundContent={
                  principal_loading ? <Spin size="small" /> : "无搜索内容"
                }
                defaultActiveFirstOption={false}
                showArrow={false}
                disabled={isDo}
                filterOption={false}
                mode="multiple"
                style={{ width: "80%" }}
                allowClear
                showSearch
              >
                {(searchplayerList || []).map((p) => {
                  return (
                    <Option
                      key={p.indexno}
                      disabled={p.disabled}
                      value={p.indexno}
                    >
                      {p.bsrno
                        ? `${p.vname}（${p.bsrno || "-"}）`
                        : `${p.vname}`}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>
          <FormItem label="报名方式" {...formItemLayout}>
            {getFieldDecorator("method", {
              rules: [{ required: true, message: "请选择报名方式!" }],
              initialValue:
                detailData.method === undefined ? "1" : detailData.method,
            })(
              <Radio.Group key={getFieldValue("method")} disabled={isDo}>
                <Radio value="1">系统分配</Radio>
              </Radio.Group>
            )}
          </FormItem>
          <FormItem label="选择身份" {...formItemLayout}>
            {getFieldDecorator("apply_type", {
              rules: [{ required: true, message: "请选择身份!" }],
              initialValue: detailData.apply_type || undefined,
            })(
              <Checkbox.Group onChange={CheckboxChange} disabled={isDo}>
                <Checkbox value="1">队员</Checkbox>
                <Checkbox value="2">预备队员</Checkbox>
                <Checkbox value="3">认证志愿者</Checkbox>
                <Checkbox value="6">志愿者</Checkbox>
              </Checkbox.Group>
            )}
          </FormItem>
          {getFieldValue("apply_type") &&
            getFieldValue("method") == "1" &&
            type == "1" && (
              <FormItem label="现场出队队员" {...formItemLayout}>
                {getFieldDecorator("object_volunteer", {
                  rules:
                    (formData.service_subject &&
                      "123".indexOf(formData.service_subject[0]) === -1) ||
                    (detailData.service_subject &&
                      "123".indexOf(detailData.service_subject[0]) === -1)
                      ? []
                      : [
                          {
                            required: true,
                            message: "现场出队队员必选！",
                          },
                        ],
                  initialValue: detailData.object_volunteer,
                })(
                  <TextArea
                    style={{ cursor: "pointer" }}
                    placeholder="点击选择现场出队队员"
                    readOnly
                    onClick={() => this.handleSelectPlayer("1")}
                    disabled={isDo}
                    autoSize={{ maxRows: 6, minRows: 2 }}
                  />
                )}
              </FormItem>
            )}
          {getFieldValue("apply_type") &&
            getFieldValue("method") == "1" &&
            type == "2" &&
            teamnos && (
              <FormItem label="现场出队队员" {...formItemLayout}>
                {getFieldDecorator("object_volunteer", {
                  rules:
                    (formData.service_subject &&
                      "123".indexOf(formData.service_subject[0]) === -1) ||
                    (detailData.service_subject &&
                      "123".indexOf(detailData.service_subject[0]) === -1)
                      ? []
                      : [
                          {
                            required: true,
                            message: "现场出队队员必选！",
                          },
                        ],
                  initialValue: detailData.object_volunteer,
                })(
                  <TextArea
                    style={{ cursor: "pointer" }}
                    placeholder="点击选择现场出队队员"
                    readOnly
                    onClick={() => this.handleSelectPlayer("1")}
                    disabled={isDo}
                    autoSize={{ maxRows: 6, minRows: 2 }}
                  />
                )}
              </FormItem>
            )}
          {getFieldValue("apply_type") &&
            getFieldValue("method") == "1" &&
            type == "1" && (
              <FormItem label="后台出队队员" {...formItemLayout}>
                {getFieldDecorator("object_volunteer_rear", {
                  initialValue: detailData.object_volunteer_rear,
                })(
                  <TextArea
                    style={{ cursor: "pointer" }}
                    placeholder="点击选择后合出队队员"
                    readOnly
                    onClick={() => this.handleSelectPlayer("2")}
                    disabled={isDo}
                    autoSize={{ maxRows: 6, minRows: 2 }}
                  />
                )}
              </FormItem>
            )}
          {getFieldValue("apply_type") &&
            getFieldValue("method") == "1" &&
            type == "2" &&
            teamnos && (
              <FormItem label="后台出队队员" {...formItemLayout}>
                {getFieldDecorator("object_volunteer_rear", {
                  initialValue: detailData.object_volunteer_rear,
                })(
                  <TextArea
                    style={{ cursor: "pointer" }}
                    placeholder="点击选择后合出队队员"
                    readOnly
                    onClick={() => this.handleSelectPlayer("2")}
                    disabled={isDo}
                    autoSize={{ maxRows: 6, minRows: 2 }}
                  />
                )}
              </FormItem>
            )}
          <div
            style={{
              width: "100%",
              height: 30,
              display: "flex",
              alignItems: "center",
              backgroundColor: "rgb(132 196 255)",
              fontWeight: "bold",
              fontSize: 20,
              padding: "20px 15px",
              borderRadius: "16px",
              color: "rgb(255 133 3)",
              justifyContent: "center",
              marginBottom: 24,
            }}
          >
            补 充 信 息
          </div>
          <FormItem label="参与部门" {...formItemLayout}>
            {getFieldDecorator("department", {
              rules: [{ required: true, message: "参与部门必填！" }],
              initialValue: detailData.department,
            })(
              <TextArea
                placeholder="如水域组、绳索组等"
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="首次接触事务时间" {...formItemLayout}>
            {getFieldDecorator("event_time", {
              rules: [{ required: true, message: "首次接触事务时间必选！" }],
              initialValue: detailData.event_time
                ? moment(detailData.event_time)
                : undefined,
            })(
              <DatePicker
                style={{ width: "100%" }}
                locale={date_locale}
                showTime
                format="YYYY年MM月DD日 HH:mm"
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>

          <FormItem label="任务进展" {...formItemLayout}>
            {getFieldDecorator("event_progress", {
              rules: [{ required: true, message: "任务进展必填！" }],
              initialValue: detailData.event_progress,
            })(
              <TextArea
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="任务图片" {...formItemLayout}>
            {getFieldDecorator("event_img", {
              rules: [{ required: true, message: "任务图片必传！" }],
              valuePropName: "fileList",
              getValueFromEvent: (e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e && e.fileList;
              },
              initialValue: edit_id
                ? (detailData.event_img || []).map((img, i) => {
                    i += 1;
                    return {
                      uid: i - i * 2,
                      status: "done",
                      response: {
                        flag: 1,
                        data: {
                          url: img,
                        },
                      },
                      name: "图片" + i,
                      thumbUrl: config.imgUrl + img,
                    };
                  })
                : [],
            })(
              <Upload
                accept="image/jpeg, image/jpg, image/png"
                action={config.serverUrl + api.ImageUpload}
                disabled={formData.event_img && formData.event_img.length >= 10}
                beforeUpload={beforeUpload}
                data={{
                  token: app.getData("token"),
                  indexno: app.getData("indexno"),
                  account: app.getData("account"),
                  upload_type: "reports",
                }}
                name="image"
                listType="picture"
                showUploadList={
                  detailData.edit_status === "1"
                    ? { showRemoveIcon: false }
                    : true
                }
                className="upload-list-inline"
              >
                <Button
                  disabled={
                    (formData.event_img && formData.event_img.length >= 10) ||
                    detailData.edit_status === "1"
                  }
                >
                  <Icon type="upload" /> 点击上传
                </Button>
              </Upload>
            )}
            <div style={{ color: "rgb(255 133 3)" }}>
              注：图片限制上传10张。
            </div>
          </FormItem>
          <FormItem label="相关人" {...formItemLayout}>
            {getFieldDecorator("relevant", {
              initialValue: detailData.relevant || "",
            })(
              <TextArea
                placeholder="参与本次活动的其他编外人员"
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="报案人" {...formItemLayout}>
            {getFieldDecorator("reporter", {
              initialValue: detailData.reporter || "",
            })(<Input disabled={detailData.edit_status === "1"} />)}
          </FormItem>
          <FormItem label="报案人联系方式" {...formItemLayout}>
            {getFieldDecorator("reporter_contact", {
              initialValue: detailData.reporter_contact || "",
            })(<Input disabled={detailData.edit_status === "1"} />)}
          </FormItem>
          <FormItem label="服务对象" {...formItemLayout}>
            {getFieldDecorator("request_object", {
              initialValue: detailData.request_object || "",
            })(<Input disabled={detailData.edit_status === "1"} />)}
          </FormItem>
          <FormItem label="服务对象联系方式" {...formItemLayout}>
            {getFieldDecorator("request_object_contact", {
              initialValue: detailData.request_object_contact || "",
            })(<Input disabled={detailData.edit_status === "1"} />)}
          </FormItem>

          <FormItem label="出队车辆数" {...formItemLayout}>
            {getFieldDecorator("action_car_number", {
              initialValue: detailData.action_car_number
                ? parseInt(detailData.action_car_number)
                : 0,
            })(
              <InputNumber
                min={0}
                precision={0}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="车牌号码" {...formItemLayout}>
            {getFieldDecorator("number_plate", {
              initialValue: detailData.number_plate || "",
            })(
              <TextArea
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="其他工具" {...formItemLayout}>
            {getFieldDecorator("other_tools", {
              initialValue: detailData.other_tools || "",
            })(
              <TextArea
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="受益人数" {...formItemLayout}>
            {getFieldDecorator("benefit_number", {
              initialValue: detailData.benefit_number
                ? Number(detailData.benefit_number)
                : 0,
            })(
              <InputNumber
                min={0}
                precision={0}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="任务总结" {...formItemLayout}>
            {getFieldDecorator("task_summary", {
              initialValue: detailData.task_summary || "",
            })(
              <TextArea
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="总结人" {...formItemLayout}>
            {getFieldDecorator("summary_person", {
              initialValue: detailData.summary_person || "",
            })(
              <TextArea
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>
          <FormItem label="百度网盘链接" {...formItemLayout}>
            {getFieldDecorator("web_link", {
              initialValue: detailData.web_link || "",
            })(
              <TextArea
                autosize={{ maxRows: 3, minRows: 2 }}
                disabled={detailData.edit_status === "1"}
              />
            )}
          </FormItem>

          {isDo ? null : (
            <FormItem wrapperCol={{ span: 12, offset: 6 }}>
              {edit_id ? null : (
                <Popconfirm
                  title="确定清空表单吗？"
                  onConfirm={this.handleReset}
                  okText="确定"
                  cancelText="取消"
                >
                  <Button>清空表单</Button>
                </Popconfirm>
              )}
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: "0 20px" }}
                loading={submit_loading}
              >
                提交
              </Button>
            </FormItem>
          )}
          <Modal
            visible={player_modal}
            title="选择出队队员"
            onCancel={this.handleClosePlayerModal}
            onOk={this.handleConfirmPlayerSel}
            width={800}
            zIndex={1001}
            maskClosable={false}
            destroyOnClose={true}
            className="ant-Tree"
            centered
            okText="确定"
            cancelText="取消"
            bodyStyle={{
              minHeight: 400,
              maxHeight: "calc(100vh - 160px)",
              height: "auto",
              overflowY: "auto",
            }}
            style={{ paddingBottom: 20 }}
          >
            <Input.Search
              placeholder="输入姓名搜索"
              onSearch={this.handleModalSearchPlayer}
            />
            <div
              hidden={!modal_search_value}
              style={{ marginTop: 12, backgroundColor: "rgb(143, 178, 201)" }}
              id="player_modal_search_count"
            />
            <Tree
              checkable
              defaultExpandAll
              onCheck={this.handleSelPlayer}
              checkedKeys={playerChecks}
              treeNodeFilterProp="title"
            >
              <TreeNode title="所有队员" key="0">
                {Object.keys(playerList).map((player, pli) => {
                  let pInfo = playerList[player];
                  return (
                    <TreeNode className="ant-title" title={player} key={player}>
                      {Object.keys(pInfo).map((sf, si) => {
                        let sfInfo = pInfo[sf];
                        return sfInfo &&
                          Array.isArray(sfInfo) &&
                          sfInfo.length > 0 &&
                          sf !== "teamno" &&
                          sf !== "province" ? (
                          <TreeNode
                            isLeaf
                            title={command.posseman(sf)}
                            key={`${player}-${sf}`}
                            className="ant-nodes"
                          >
                            {sfInfo.map((p1, pi) => {
                              return loopPlayerTreeNode(p1);
                            })}
                          </TreeNode>
                        ) : null;
                      })}
                    </TreeNode>
                  );
                })}
              </TreeNode>
            </Tree>
          </Modal>
          <Modal
            visible={player_modal2}
            title="选择出队队伍"
            onCancel={this.handleClosePlayerModal2}
            onOk={this.handleConfirmPlayerSel2}
            width={1200}
            zIndex={1001}
            maskClosable={false}
            destroyOnClose={true}
            className="ant-Trees"
            centered
            okText="确定"
            cancelText="取消"
            bodyStyle={{
              minHeight: 400,
              maxHeight: "calc(100vh - 160px)",
              height: "auto",
              overflowY: "auto",
            }}
            style={{ paddingBottom: 20 }}
          >
            <Input.Search
              placeholder="输入队伍搜索"
              onSearch={this.handleModalSearchPlayer2}
            />
            <div
              hidden={!modal_search_value2}
              style={{ marginTop: 12, backgroundColor: "rgb(143, 178, 201)" }}
              id="player_modal_search_count"
            />
            <Tree
              checkable
              defaultExpandAll
              onCheck={this.handleSelPlayer2}
              checkedKeys={playerChecks2}
              treeNodeFilterProp="title"
            >
              <TreeNode className="Treenode" title="所有队伍" key="0">
                {playerList2.map((p1, pi) => {
                  return loopPlayerTreeNode2(p1);
                })}
              </TreeNode>
            </Tree>
          </Modal>
          <Modal
            visible={player_modal3}
            title="选择队伍等级"
            onCancel={this.handleClosePlayerModal3}
            onOk={this.handleConfirmPlayerSel3}
            width={800}
            zIndex={1001}
            maskClosable={false}
            destroyOnClose={true}
            className="ant-Tree"
            centered
            okText="确定"
            cancelText="取消"
            bodyStyle={{
              minHeight: 400,
              maxHeight: "calc(100vh - 160px)",
              height: "auto",
              overflowY: "auto",
            }}
            style={{ paddingBottom: 20 }}
          >
            <Input.Search
              placeholder="输入等级搜索"
              onSearch={this.handleModalSearchPlayer3}
            />
            <div
              hidden={!modal_search_value3}
              style={{ marginTop: 12, backgroundColor: "rgb(143, 178, 201)" }}
              id="player_modal_search_count"
            />
            <Tree
              checkable
              defaultExpandAll
              onCheck={this.handleSelPlayer3}
              checkedKeys={playerChecks3}
              treeNodeFilterProp="title"
            >
              <TreeNode title="所有等级" key="0">
                {playerList3.map((player, pli) => {
                  return (
                    <TreeNode
                      className="ant-node"
                      title={player.ally_grade}
                      key={pli}
                    >
                      {player.province_list && player.province_list.length > 0
                        ? player.province_list.map((p1, index) => {
                            return loopPlayerTreeNode3(p1);
                          })
                        : null}
                    </TreeNode>
                  );
                })}
              </TreeNode>
            </Tree>
          </Modal>
        </Form>
      </div>
    );
  }
}

TaskAdd.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDuration: PropTypes.func.isRequired,
  setFormClear: PropTypes.func,
  teamno: PropTypes.any,
  edit_id: PropTypes.any,
  select_team: PropTypes.any,
  type: PropTypes.any,
};

export default Form.create()(TaskAdd);



// WEBPACK FOOTER //
// ./src/routes/sign/TaskAdd2.jsx